import { useMemo } from 'react';
import { useTagsQuery } from '../../api/tagApi';
import { useClientContext } from '../../hooks/useClientContext';
import { TagPickerView } from './TagPickerView';

export interface DraftTagPickerProps {
  tagIds: number[];
  onChange: (tagIds: number[]) => void;
  disabled?: boolean;
}

/**
 * Tag picker for content that doesn't exist yet (the "new lesson" form) — there's
 * no id to assign a tag join-row against yet, so selections live in local state
 * here and are applied once the record is actually created.
 */
export function DraftTagPicker({ tagIds, onChange, disabled = false }: DraftTagPickerProps) {
  const { clientContext } = useClientContext();
  const { data: library } = useTagsQuery({ assignedAccountId: clientContext?.id });

  const tags = useMemo(
    () =>
      (library?.items ?? [])
        .filter((tag) => tagIds.includes(tag.id))
        .map(({ id, name }) => ({ id, name })),
    [library, tagIds],
  );

  return (
    <TagPickerView
      tags={tags}
      allTags={library?.items ?? []}
      countKey="lessonCount"
      onAssign={(tagId) => onChange([...tagIds, tagId])}
      onUnassign={(tagId) => onChange(tagIds.filter((id) => id !== tagId))}
      disabled={disabled}
    />
  );
}
